import React from "react";
import Routes from "./Routes";
import { ThemeProvider } from './contexts/ThemeContext';
import { SocketProvider } from './contexts/SocketContext';

function App() {
  return (
    <ThemeProvider>
      <SocketProvider>
        <Routes />
      </SocketProvider>
    </ThemeProvider>
  );
}

export default App;